module.exports = __webpack_public_path__ + "static/media/wmca.dca7bac6.png";